import types from './types'

export const saveState = (action) => ({ type: types.STATE_SAVE_ATTEMPT, action })
export const saveStateSuccess = () => ({ type: types.STATE_SAVE_SUCCESS })
export const saveStateFailure = (error, code) => ({ type: types.STATE_SAVE_FAILURE, error, code })

export const loadState = () => ({ type: types.STATE_LOAD_ATTEMPT })
export const loadStateSuccess = (data) => ({ type: types.STATE_LOAD_SUCCESS, data })
export const loadStateFailure = (error, code) => ({ type: types.STATE_LOAD_FAILURE, error, code })

export const unsavedStateChanges = () => ({ type: types.STATE_UNSAVED })
export const savedStateChanges = () => ({ type: types.STATE_SAVED })

export const setFeatureToggles = (featureToggles) => ({ type: types.SET_FEATURE_TOGGLES, featureToggles })

export default {
  saveState,
  saveStateSuccess,
  saveStateFailure,
  loadState,
  loadStateSuccess,
  loadStateFailure,
  unsavedStateChanges,
  savedStateChanges,
  setFeatureToggles,
}
